// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"b6b2631a","535":"156cf7ce","573":"136c6b18","738":"1b684d13","943":"6ffef09c"}[chunkId] + ".chunk.js";
};